function initialiseGallery() {
  jQuery(function ($) {
    let carousel = new Swiper(
      '.photo-video-gallery__inner-wrapper.swiper:not(.swiper-initialized)',
      {
        spaceBetween: 8,
        slidesPerView: 'auto',
        allowTouchMove: true,
        navigation: {
          nextEl: '.photo-video-gallery__inner-wrapper .swiper-button-next',
          prevEl: '.photo-video-gallery__inner-wrapper .swiper-button-prev',
        },
        scrollbar: {
          el: '.photo-video-gallery__inner-wrapper .swiper-scrollbar',
          draggable: true,
          dragSize: 103,
        },
        breakpoints: {
          1024: {
            scrollbar: {
              dragSize: 377,
            },
          },
        },
      },
    );
  });
}

function hydrateSlideClicks() {
  const slides = document.querySelectorAll(
    '.photo-video-gallery__inner-wrapper .photo-video-gallery__thumbnail',
  );
  const frame = document.querySelector(
    '.photo-video-gallery__modal .modal-frame',
  );
  const modal = document.querySelector('.photo-video-gallery__modal');
  const iframe = modal.querySelector('.embed-video-player');
  const video = modal.querySelector('.video-file-player');
  const autoplay = modal.dataset.autoplay === 'true';

  slides.forEach((slide) => {
    slide.addEventListener('click', () => {
      const embedUrl = slide.dataset.embedUrl;
      const videoData = slide.dataset.video;
      const aspectRatio = slide.dataset.aspectRatio;

      if (!embedUrl && !videoData) return;

      if (embedUrl) {
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' +
          embedUrl +
          '?rel=0&modestbranding=1' +
          (autoplay ? '&autoplay=1' : '');
        iframe.classList.add('active');
        video.classList.remove('active');
      } else if (videoData) {
        var parsed = JSON.parse(videoData);
        var sources = parsed.sources || [];
        var mp4Source =
          sources.find(function (s) {
            return s.mime_type === 'video/mp4';
          }) || sources[0];
        if (mp4Source) {
          video.innerHTML = `<source src="${mp4Source.url}" type="${mp4Source.mime_type}">`;
          video.load();
          video.classList.add('active');
          iframe.classList.remove('active');
          if (autoplay) {
            video.play();
          }
        }
      }

      modal.classList.add('active');
      document.querySelector('html').classList.add('overflow-y-hidden');

      if (aspectRatio) {
        frame.classList.remove('landscape', 'portrait');
        frame.classList.add(aspectRatio.toLowerCase());
      }
    });
  });
}

function hydratePopupModal() {
  const modal = document.querySelector('.photo-video-gallery__modal');
  const closeBtn = modal.querySelector('.modal-close');
  const overlay = modal.querySelector('.modal-overlay');
  const iframe = modal.querySelector('.embed-video-player');
  const video = modal.querySelector('.video-file-player');

  function closeModal() {
    modal.classList.remove('active');
    document.querySelector('html').classList.remove('overflow-y-hidden');
    iframe.src = '';
    iframe.classList.remove('active');
    video.pause();
    video.removeAttribute('src');
    video.innerHTML = '';
    video.load();
    video.classList.remove('active');
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
}

window.addEventListener('DOMContentLoaded', function () {
  initialiseGallery();
  hydrateSlideClicks();
  hydratePopupModal();
});
